<template>
  <button
    type="button"
    :class="classes"
    :aria-pressed="value"
    autocomplete="off"
    :disabled="disabled"
    @click.stop="active = !active"
    @keyup.enter.stop="active = !active"
  >
    <div class="handle" />
  </button>
</template>

<script>
export default {
  name: 'BtnSwitch',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    xs: {
      type: Boolean,
      required: false,
      default: false,
    },
    sm: {
      type: Boolean,
      required: false,
      default: false,
    },
    lg: {
      type: Boolean,
      required: false,
      default: false,
    },
    secondary: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    warning: {
      type: Boolean,
      required: false,
      default: false,
    },
    danger: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        btn: true,
        'btn-lg': this.lg,
        'btn-sm': this.sm,
        'btn-xs': this.xs,
        'btn-toggle': true,
        'btn-secondary': this.secondary,
        'btn-warning': this.warning,
        'btn-danger': this.danger,
        active: this.value,
      };
    },
    active: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
